export default __webpack_public_path__ + "static/media/P10013.1d9bae44.png";